<form
  class="form-container"
  [formGroup]="form"
  [attr.data-test-id]="formContent.formAttribute.dataTestId"
  [id]="formContent.formAttribute.dataTestId"
>
  <ng-container
    *ngFor="let fieldAttribute of formContent.fieldAttributes"
    dynamicField
    [fieldAttribute]="fieldAttribute"
    [form]="form"
  >
  </ng-container>
</form>
